export const MOCK_USER = {
  name: 'John Doe',
  email: 'john@example.com',
  profileImage: '',
  isOwner: true,
  isHidden: false,
  id: 1,
  tfaEnabled: false,
  createdTs: 0,
  teamId: 1,
  clusterId: 'cluster-1',
  teamName: 'Team',
  emailVerified: true,
  isEmailVerificationBlock: false
};
